import React, { useEffect, useReducer, useRef, useState } from 'react'
import {
  Input,
  Form,
  Row,
  Button,
  message,
  Radio,
  Col,
  Tooltip,
  Select,
  List,
  Spin,
  InputNumber,
} from 'antd'
import { FormInstance } from 'antd/lib/form'
import { filteDisabled, filteHidden } from '../ControlformState/useFormState'
import { useTypedSelector } from '../../redux/store'
import Style from './detail.module.scss'
import {
  GET_OWNER_PAGES_API,
  GET_TYPE_API,
  // GET_ALLUNIT_API,
  GET_PRODUCT_CHECKMAN_API,
  GET_BRANDPAGE,
  GET_UNIT_PAGE,
  GET_TAXINFO_BY_CATEGORYCODE,
} from '../../api/MaterialApi'
import {
  RedoOutlined,
  CloseCircleOutlined,
  QuestionCircleOutlined,
} from '@ant-design/icons'
import CustomModal from '../../components/ModalUser'
import CustomeIcon from '../../components/IconUser'
import CustomTreeAll, { selectNodeParam } from '../../components/TreeAll'
import {
  formatStr,
  checkASCII,
  htmlToRed,
  formatSpecialCharacter,
  MaterialType,
  packingFeeList,
  testingFeeList,
  getFeeText,
  getSupplierId,
  isResponseCodeSuccess,
  // debounce,
  formatterEditPrice,
} from '../../tools/util'
import MaterialPopTable, {
  tableresultData,
  filterData,
  tableParam,
} from '../../components/MaterialTable'
import {
  GET_PARENTDEPARTMENT_API,
  GET_STAFF_API,
  FETCH_PURCHASE_API,
} from '../../api/CommonApi'
import { GET_PRODUCTMANAGER_LIST } from '../../api/System_Api'
import {
  setIncludePackingAction,
  setIncludeTestingAction,
  CategorySourceData,
} from './reducer'
import { useDispatch } from 'react-redux'
import SingleAbleCheckbox from '../../components/SingleAbleCheckbox'
import InfiniteScroll from 'react-infinite-scroll-component'
import OneZeroCheckbox from '@/components/OneZeroCheckbox'
// 7.1.3
import { materialTypeEnum } from '@/global/enum/product'
import { GlobalStorage } from '@/global/storage'
import { productForbidCharValidator } from '@/hooks/validate'
import { PreCheckErrors } from '@/api/MaterialApi'
import Extra from './extra'
import AiCategoryRecommend from './AiCategoryRecommend'
import {
  fetchAiCategoryRecommendations,
  getHighestConfidenceRecommendation,
  toCategorySelectNodeParam,
} from './aiCategoryRecommendUtils'

const ACTION_TYPE = {
  SWITCH_VISIBLE: 'MAIN/SWITCH_VISIBLE', // 控制弹窗显示隐藏
  SET_SWITCH_TYPE: 'MAIN/SET_SWITCH_TYPE', // 设置操作数据类型
  SET_DATA: 'MAIN/SET_DATA', // 设置数据
  SET_DATALIST: 'MAIN/SET_DATALIST', // 设置 过滤 数据
  SET_KEYNAME: 'MAIN/SET_KEYNAME', // 设置 搜索 数据
  SET_LOADING: 'MAIN/SET_LOADING', // 设置loading
  SET_OWNER_DATA: 'SET_OWNER_DATA', // 货主
  SET_SEARCH_PARAM: 'SET_SEARCH_PARAM', // 弹窗搜索关键字
  SET_UNIT_OPTION: 'SET_UNIT_OPTION', // 设置单位
  SET_PAGE: 'SET_PAGE',
  SET_BRAND_DATA: 'SET_BRAND_DATA',
  SEARCH_VALUE: 'SEARCH_VALUE',
}
// 数据类型
type Operationdatatype =
  | 'Brand'
  | 'Owner'
  | 'Category'
  | 'Unit'
  | 'Procurement'
  | 'ProcurementDept'
  | 'ExaminationType'
  | 'ExaminationPerson'
  | 'deliveryday'
  | 'ProductManger'

interface select {
  label: string
  value: string
}
interface State {
  visible: boolean
  dataType: Operationdatatype
  dataSource: tableresultData // 数据源
  dataList: tableresultData
  keyName: string // 搜索数据
  loading: boolean
  ownerData: any[] // 货主列表
  searchSelectParam: { owner?: string } // 弹窗搜索关键字
  unitOption: select[]
  currentPage: number
  brandData: tableresultData
  searchValue: string
}
const defaultState: State = {
  visible: false,
  dataType: 'Brand',
  dataSource: {
    current: 1,
    total: 0,
    data: [],
  },
  dataList: { current: 1, total: 0, data: [] },
  keyName: '',
  loading: false,
  ownerData: [],
  searchSelectParam: { owner: '' },
  unitOption: [],
  currentPage: 1,
  brandData: {
    current: 1,
    total: 0,
    data: [],
  },
  searchValue: '',
}
const reducer = (
  state = defaultState,
  action: { type: string; value?: any },
) => {
  const arr = { ...state }
  switch (action.type) {
    case ACTION_TYPE.SWITCH_VISIBLE:
      arr.visible = action.value
      return arr
    case ACTION_TYPE.SET_SWITCH_TYPE:
      arr.dataType = action.value
      return arr
    case ACTION_TYPE.SET_UNIT_OPTION:
      arr.unitOption = action.value
      return arr
    case ACTION_TYPE.SET_PAGE:
      arr.currentPage = action.value
      return arr
    case ACTION_TYPE.SET_BRAND_DATA:
      arr.brandData = action.value
      return arr
    case ACTION_TYPE.SEARCH_VALUE:
      arr.searchValue = action.value
      return arr
    case ACTION_TYPE.SET_DATA:
      arr.dataSource = action.value
      return arr
    case ACTION_TYPE.SET_DATALIST:
      arr.dataList = action.value
      return arr
    case ACTION_TYPE.SET_KEYNAME:
      arr.keyName = action.value
      return arr
    case ACTION_TYPE.SET_LOADING:
      arr.loading = action.value
      return arr
    case ACTION_TYPE.SET_OWNER_DATA:
      arr.ownerData = action.value
      return arr
    case ACTION_TYPE.SET_SEARCH_PARAM:
      arr.searchSelectParam = action.value
      return arr
    default:
      return arr
  }
}

// 搜索内容
const changeSearchSelectParamAction = (param: any) => ({
  type: ACTION_TYPE.SET_SEARCH_PARAM,
  value: param,
})

const setSwitchAction = (param: boolean) => ({
  type: ACTION_TYPE.SWITCH_VISIBLE,
  value: param,
})
const setBrandDataAction = (param: tableresultData) => ({
  type: ACTION_TYPE.SET_BRAND_DATA,
  value: param,
})
const setSearchValueAction = (param: string) => ({
  type: ACTION_TYPE.SEARCH_VALUE,
  value: param,
})
const setLoadingAction = (param: boolean) => ({
  type: ACTION_TYPE.SET_LOADING,
  value: param,
})
const setDataTypeAction = (param: Operationdatatype) => ({
  type: ACTION_TYPE.SET_SWITCH_TYPE,
  value: param,
})
const setDataAction = (param: tableresultData) => ({
  type: ACTION_TYPE.SET_DATA,
  value: param,
})

const setDataFilterAction = (param: tableresultData) => ({
  type: ACTION_TYPE.SET_DATALIST,
  value: param,
})
const setKeyNameAction = (param: string) => ({
  type: ACTION_TYPE.SET_KEYNAME,
  value: param,
})
// 搜索货主
const setOwnerDataAction = (param: any[]) => ({
  type: ACTION_TYPE.SET_OWNER_DATA,
  value: param,
})

export const adjustPriceRules = [
  {
    pattern: /^(([1-9]{1}\d*)|(0{1}))(\.\d{1,2})?$/,
    message: '请输入大于0且含有2位小数的数字',
  },
]

export const priceRules = [
  {
    pattern: /^(?!0(\.0{1,2})?$)([1-9]\d{0,6}(\.\d{1,2})?|0\.\d{1,2})$/,
    message: '大于0保留两位小数，小于9999999.99',
  },
]

export const weightRules = [
  {
    pattern: /^(?!0(\.0*)?$)(?![0-9]{14,}\b)\d{1,13}(\.\d{0,13})?$/,
    message: '请输入大于0且含有两位小数的1-13位数字',
  },
  {
    pattern: /^(([1-9]{1}\d*)|(0{1}))(\.\d{1,2})?$/,
    message: '请输入大于0且含有两位小数的1-13位数字',
  },
]

interface Props {
  form: FormInstance
  categoryReadOnly?: boolean
  onChangeCate?: (
    e: string,
    type?: string,
    materialCode?: string,
    frontendHintText?: string,
  ) => void // 类目改变
  onChangeSale?: (e: string) => void // 品牌改变
  onChangeDept?: (e: string) => void // 部门改变
  currentThis?: any // 当前
  tempCode?: string
  unitDisabled?: boolean // 基本单位是否禁用
  showUnitTip?: boolean // 基本单位备注
  getTempCode?: (preCode?: string) => Promise<void> // 获取临时编码
  materialType?: MaterialType
  onFieldsChange: () => void
  preCheckErrors?: PreCheckErrors
  aiAuditErrorReasonForField?: any
}

// 主要信息
const Maininfo: React.FC<Props> = (props) => {
  const {
    form,
    categoryReadOnly = false,
    onChangeCate,
    onChangeDept,
    tempCode,
    unitDisabled,
    showUnitTip,
    getTempCode,
    materialType,
    onFieldsChange,
    preCheckErrors,
    aiAuditErrorReasonForField,
  } = props
  const { FormState } = useTypedSelector((state) => state.ControlformState)
  const { includeTestingFee, includePackingFee } = useTypedSelector(
    (state) => state.goodsReducer,
  )
  const dispatchRedux = useDispatch()
  const [state, dispatch] = useReducer(reducer, defaultState)
  const {
    visible,
    dataType,
    dataList,
    keyName,
    loading,
    ownerData,
    searchSelectParam,
    brandData,
  } = state
  const { treeList } = useTypedSelector((state) => state.treeReducer)
  const [loadingList, setLoadingList] = useState(false)
  const [brandOpen, setBrandOpen] = useState(false)
  const [unitOpen, setUnitOpen] = useState(false)
  const [onSearchValue, setOnSearchValue] = useState('')
  const [aiCategoryRecommendLoading, setAiCategoryRecommendLoading] =
    useState(false)
  const [categoryRecommendMaterialName, setCategoryRecommendMaterialName] =
    useState('')
  const [categoryRecommendDescription, setCategoryRecommendDescription] =
    useState('')
  const timeoutId = useRef<NodeJS.Timeout | null>(null)
  useEffect(() => {
    dispatchRedux(setIncludeTestingAction(form.getFieldValue('testingFee')))
    dispatchRedux(setIncludePackingAction(form.getFieldValue('packingExpense')))
    // eslint-disable-next-line
  }, [form.getFieldValue('testingFee'), form.getFieldValue('packingExpense')])

  useEffect(() => {
    if (tempCode) {
      form.setFieldsValue({
        tempCode: tempCode,
      })
    }
    // eslint-disable-next-line
  }, [tempCode])

  // 刷新 采购人员
  async function onRefresh() {
    message.loading('数据正在刷新中，请稍后...', 0)
    const resData: any = await FETCH_PURCHASE_API()
    if (resData.code === 0) {
      message.success('刷新成功！')
    }
  }

  // 点击输入框
  const onClickInput = async (param: Operationdatatype) => {
    if (
      param === 'Category' &&
      (filteDisabled('catoyid', FormState) || aiCategoryRecommendLoading)
    ) {
      return
    }
    if (param === 'Category') {
      setCategoryRecommendMaterialName(form.getFieldValue('name') || '')
      setCategoryRecommendDescription(form.getFieldValue('remakers') || '')
    }
    //  显示弹窗 loading 设置当前操作类型
    dispatch(setSwitchAction(true))
    dispatch(setLoadingAction(true))
    dispatch(setDataTypeAction(param))
    let resData: tableresultData = {
      current: 1,
      total: 0,
      data: [],
    }
    if (param === 'Owner') {
      resData = await getOwnerData()
    }
    if (param === 'Brand') {
      resData = await getBrandData(1)
    }
    if (param === 'Category') {
    }
    if (param === 'Unit') {
      resData = await getUnitData(1)
    }
    if (param === 'Procurement') {
      resData = await getProcurementData(1)
    }
    if (param === 'ProcurementDept') {
      resData = await getProcurementDept(1)
    }
    if (param === 'ExaminationType') {
      resData = await getExaminationType(1)
    }
    if (param === 'ProductManger') {
      resData = await getProductManager(1)
    }
    if (param === 'ExaminationPerson') {
      resData = await getExaminationPerson(1)
    }
    // 存原始数据
    dispatch(setDataAction(resData))
    // 设置过滤数据
    dispatch(setDataFilterAction(resData))
    // loading结束
    dispatch(setLoadingAction(false))
  }

  // 搜索数据
  async function onSearchData(e: string) {
    let data: tableresultData = {
      current: 1,
      total: 0,
      data: [],
    }
    // 记录搜索条件
    dispatch(setKeyNameAction(e))
    switch (dataType) {
      case 'Owner':
        data = searchOwner(e)
        break
      case 'Brand':
        data = await getBrandData(1, e)
        break
      case 'Category':
        break
      case 'Unit':
        data = await getUnitData(1, e)
        break
      case 'Procurement':
        data = await getProcurementData(1, e)
        break
      case 'ProcurementDept':
        data = await getProcurementDept(1, e)
        break
      case 'ExaminationType':
        data = await getExaminationType(1, e)
        break
      case 'ProductManger':
        data = await getProductManager(1, e)
        break
      case 'ExaminationPerson':
        data = await getExaminationPerson(1, e)
        break
      default:
        break
    }
    dispatch(setDataFilterAction(data))
  }

  // 分页
  const onChangePage = async (page: number) => {
    //   loading
    dispatch(setLoadingAction(true))
    let resData: tableresultData = {
      current: 1,
      total: 0,
      data: [],
    }
    if (dataType === 'Brand') {
      resData = await getBrandData(page, keyName)
    }
    if (dataType === 'Category') {
    }
    if (dataType === 'Unit') {
      resData = await getUnitData(page, keyName)
    }
    if (dataType === 'Procurement') {
      resData = await getProcurementData(page, keyName)
    }
    if (dataType === 'ProcurementDept') {
      resData = await getProcurementDept(page, keyName)
    }
    if (dataType === 'ExaminationType') {
      resData = await getExaminationType(page, keyName)
    }
    if (dataType === 'ProductManger') {
      resData = await getProductManager(page, keyName)
    }
    if (dataType === 'ExaminationPerson') {
      resData = await getExaminationPerson(page, keyName)
    }
    // 存原始数据
    dispatch(setDataAction(resData))
    // 设置过滤数据
    dispatch(setDataFilterAction(resData))
    // loading结束
    dispatch(setLoadingAction(false))
  }

  // 获取货主数据
  const getOwnerData = async (): Promise<tableresultData> => {
    const resData = await GET_OWNER_PAGES_API({
      supplierid: getSupplierId(),
    })
    if (resData.code === 0) {
      resData.data.forEach((item: any) => {
        item.id = item.mdmId
      })
      dispatch(setOwnerDataAction(resData.data))
      return {
        data: resData.data,
      }
    }
    return {
      current: 1,
      total: 0,
      data: [],
    }
  }

  // 获取货主数据
  const searchOwner = (str?: string) => {
    dispatch(changeSearchSelectParamAction({ owner: str }))
    return {
      current: 1,
      total: 0,
      data: str
        ? ownerData.filter((item) =>
            new RegExp(formatSpecialCharacter(str), 'gi').test(item.name),
          )
        : [...ownerData],
    }
  }

  // 获取品牌数据
  const getBrandData = async (
    page: number,
    str?: string,
    loading?: boolean,
  ): Promise<tableresultData> => {
    setLoadingList(true)
    const resData: any = await GET_BRANDPAGE({
      brandName: str, // 筛选条件
      supplierId: getSupplierId(),
      pageNo: page, // 页码
      pageSize: 20, // 分页尺寸
    })
    if (resData.code === 0) {
      const data = resData.data.content
      const arr = data.map((item: any) => ({
        name: `${item.brandNameCn}/${item.brandNameEn}/${item.brandCode}`,
        brandEn: item.brandNameEn,
        brandCn: item.brandNameCn,
        id: Math.random().toString(36).substr(2),
        mdmId: item.brandMdmId,
      }))
      const result = loading ? brandData.data.concat(arr) : arr
      dispatch(
        setBrandDataAction({
          current: resData.data.pageNo,
          total: resData.data.totalCount,
          data: result,
        }),
      )
      dispatch(setSearchValueAction(str || ''))
      setLoadingList(false)
      return {
        current: resData.data.pageNo,
        total: resData.data.totalCount,
        data: result,
      }
    }
    dispatch(
      setBrandDataAction({
        current: 1,
        total: 0,
        data: [],
      }),
    )
    setLoadingList(false)
    return brandData
  }

  // 获取单位数据
  const getUnitData = async (
    page: number,
    str?: string,
    loading?: boolean,
  ): Promise<tableresultData> => {
    setLoadingList(true)
    const resData: any = await GET_UNIT_PAGE({
      name: str, // 筛选条件
      pageNo: page, // 页码
      pageSize: 20, // 分页尺寸
    })
    if (isResponseCodeSuccess(resData.code))
      if (resData.code === 0) {
        const data = resData.data.content
        // type 1 基准单位 成本和基本单位相同数据 其他全部展示 value 显示unit数值
        // const list = data.filter((item: any) => item.type === '1');
        const arr = data.map(
          (item: { name: string; type: string; unit: string }) => ({
            name: item.name + '/' + item.unit,
            code: item.unit,
            id: item.unit,
          }),
        )
        const result = loading ? brandData.data.concat(arr) : arr
        dispatch(
          setBrandDataAction({
            current: resData.data.pageNo,
            total: resData.data.totalCount,
            data: result,
          }),
        )
        dispatch(setSearchValueAction(str || ''))
        setLoadingList(false)
        return {
          current: resData.data.pageNo,
          total: resData.data.totalCount,
          data: result,
        }
      }
    dispatch(
      setBrandDataAction({
        current: 1,
        total: 0,
        data: [],
      }),
    )
    setLoadingList(false)
    return brandData
  }

  const renderSearchList = (type: string) => {
    const open = type === 'brand' ? brandOpen : unitOpen
    const throttleSearch = (value: string) => {
      setOnSearchValue(value)
      if (!value) {
        dispatch(
          setBrandDataAction({
            current: 1,
            total: 0,
            data: [],
          }),
        )
        return
      }
      if (timeoutId) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        clearTimeout(timeoutId.current)
      }
      timeoutId.current = setTimeout(() => {
        if (type === 'brand') {
          setBrandOpen(true)
          getBrandData(1, value)
        } else {
          setUnitOpen(true)
          getUnitData(1, value)
        }
      }, 200)
    }
    return {
      onSearch: throttleSearch,
      dropdownRender: () => (
        <div
          id={'scrollableDiv' + type}
          style={{ height: 200, display: open ? '' : 'none' }}
        >
          <InfiniteScroll
            dataLength={brandData.data.length}
            next={() =>
              type === 'brand'
                ? getBrandData(
                    (brandData.current || 0) + 1,
                    onSearchValue,
                    true,
                  )
                : getUnitData(
                    (brandData.current || 0) + 1,
                    form.getFieldValue(type),
                    true,
                  )
            }
            hasMore={(brandData.current || 0) * 20 < (brandData.total || 0)}
            loader={<Spin spinning={loadingList} />}
            endMessage=""
            scrollableTarget={'scrollableDiv' + type}
            height={200}
          >
            <List
              dataSource={brandData.data}
              renderItem={(item) => (
                <List.Item
                  key={item.id}
                  onClick={(e) => {
                    e.stopPropagation()
                    if (type === 'brand') {
                      clickBrand(item)
                    } else {
                      clickUnit(item)
                    }
                  }}
                >
                  <div className={Style['brand-item']}>{item.name}</div>
                </List.Item>
              )}
            />
          </InfiniteScroll>
        </div>
      ),
    }
  }

  // 获取采购员
  const getProcurementData = async (page: number, str?: string) => {
    const depId = form.getFieldValue('procurementDept')
    const resData: any = await GET_STAFF_API({
      deptId: depId ? depId : '',
    })
    if (resData.code === 0) {
      const data = resData.data
      // 设置id
      const arr = data.map(
        (item: {
          id: string
          empName: string
          empId: string
          empCode: string
          deptId: string
          deptName: string
          jobName: string
        }) => ({
          name: `${item.empName}-${item.deptName}-${item.jobName}`,
          id: item.empId,
          empId: item.empId,
          deptId: item.deptId,
          deptName: item.deptName,
          code: item.empCode,
        }),
      )
      return filterData(arr, str, String(page))
    }
    return {
      current: 1,
      total: 0,
      data: [],
    }
  }

  // 获取采购部门
  const getProcurementDept = async (
    page: number,
    str?: string,
  ): Promise<tableresultData> => {
    const create_code = form.getFieldValue('create_code')
    const resData: any = await GET_PARENTDEPARTMENT_API({
      createcode: create_code ? create_code : '', // 创建组织
      pushState: '1', // 推送状态
    })
    if (resData.code === 0) {
      const data = resData.data
      const arr = data.map(
        (item: { name: string; id: string; code: string }) => ({
          name: item.name,
          id: item.id,
          code: item.code,
        }),
      )
      return filterData(arr, str, String(page))
    }
    return {
      current: 1,
      total: 0,
      data: [],
    }
  }

  // 获取考核类别
  const getExaminationType = async (
    page: number,
    str?: string,
  ): Promise<tableresultData> => {
    const depId = form.getFieldValue('procurementDept')
    const resData: any = await GET_TYPE_API({
      deptId: depId, // 部门id
    })
    if (resData.code === 0) {
      const data = resData.data
      const arr = data.map((item: { name: string; code: string }) => ({
        name: item.name,
        code: item.code,
        id: item.code,
      }))
      return filterData(arr, str, String(page))
    }
    return {
      current: 1,
      total: 0,
      data: [],
    }
  }

  // 获取考核人员
  const getExaminationPerson = async (
    page: number,
    str?: string,
  ): Promise<tableresultData> => {
    const resData: any = await GET_PRODUCT_CHECKMAN_API({
      key: str, // 搜索内容
      limit: 10, // 分页尺寸
      page: page, // 页码
    })
    if (resData.code === 0) {
      const data = resData.data
      const total = resData.count
      const current = resData.curPage
      const arr = data.map(
        (item: { name: string; id: string; code: string }) => ({
          name: item.name,
          id: item.id,
          code: item.code,
        }),
      )
      return {
        current: current,
        total: total,
        data: arr,
      }
    }
    return {
      current: 1,
      total: 0,
      data: [],
    }
  }

  // 获取产品经理
  const getProductManager = async (
    page: number,
    str?: string,
  ): Promise<tableresultData> => {
    const resData = await GET_PRODUCTMANAGER_LIST({
      name: str,
      limit: 10, // 分页尺寸
      page: page, // 页码
    })
    if (resData.code === 0) {
      const data = resData.data
      const total = resData.count
      const current = resData.curPage
      const arr = data.map(
        (item: { name: string; id: string }, index: number) => ({
          name: item.name,
          id: item.id,
          code: index + 1,
        }),
      )
      return {
        current: current,
        total: total,
        data: arr,
      }
    }
    return {
      current: 1,
      total: 0,
      data: [],
    }
  }

  const clickBrand = (e: tableParam) => {
    form.setFieldsValue({
      brand: e.name,
      brandMdmId: e.mdmId, // mdmid
      brandNameCn: e.brandCn, // 选择的品牌是否可售不可售
      brandNameEn: e.brandEn,
    })
    setBrandOpen(false)
    dispatch(setSearchValueAction(e.name))
    dispatch(
      setBrandDataAction({
        current: 1,
        total: 0,
        data: [],
      }),
    )
    setTimeout(() => {
      const item = document.getElementById('brand')
      if (item) {
        item.blur()
      }
    })
  }

  const clickUnit = (e: tableParam) => {
    // 改变基本单位 同步改变 库存单位 成本单位 销售单位 销售计价单位 采购单位 采购计价单位
    form.setFieldsValue({
      baseunit: e.id,
      baseunitName: e.name,
      inventoryunit: e.id,
      inventoryunitName: e.name,
      costunit: e.id,
      costunitName: e.name,
      salesunit: e.id,
      salesunitName: e.name,
      salesvaluaunit: e.id,
      salesvaluaunitName: e.name,
      procureunit: e.id,
      procureunitName: e.name,
      procurevaluaunit: e.id,
      procurevaluaunitName: e.name,
    })
    setUnitOpen(false)
    dispatch(setSearchValueAction(e.name))
    dispatch(
      setBrandDataAction({
        current: 1,
        total: 0,
        data: [],
      }),
    )
    setTimeout(() => {
      const item = document.getElementById('unitBasic')
      if (item) {
        item.blur()
      }
    })
  }

  // 选中当前行数据
  const onClickRow = (e: tableParam) => {
    if (dataType === 'Brand') {
      form.setFieldsValue({
        brand: e.name,
        brandMdmId: e.mdmId, // mdmid
        brandNameCn: e.brandCn, // 选择的品牌是否可售不可售
        brandNameEn: e.brandEn,
      })
    } else if (dataType === 'Unit') {
      // 改变基本单位 同步改变 库存单位 成本单位 销售单位 销售计价单位 采购单位 采购计价单位
      form.setFieldsValue({
        baseunit: e.id,
        baseunitName: e.name,
        inventoryunit: e.id,
        inventoryunitName: e.name,
        costunit: e.id,
        costunitName: e.name,
        salesunit: e.id,
        salesunitName: e.name,
        salesvaluaunit: e.id,
        salesvaluaunitName: e.name,
        procureunit: e.id,
        procureunitName: e.name,
        procurevaluaunit: e.id,
        procurevaluaunitName: e.name,
      })
      // return `基本单位`;
    } else if (dataType === 'Procurement') {
      // 选中采购 固定采购部门
      form.resetFields(['examinationType', 'examinationTypeName'])
      form.setFieldsValue({
        procurement: e.empId,
        procurementName: e.name,
        procurementDept: e.deptId,
        procurementDeptName: e.deptName,
      })
      if (onChangeDept) {
        onChangeDept(e.deptId)
      }
      // return `采购员`;
    } else if (dataType === 'ProcurementDept') {
      // 选中部门 重置采购员 考核类别
      form.resetFields([
        'procurement',
        'procurementName',
        'examinationType',
        'examinationTypeName',
      ])
      form.setFieldsValue({
        procurementDept: e.id,
        procurementDeptName: e.name,
      })
      if (onChangeDept) {
        onChangeDept(e.id)
      }
      // return `采购部门`;
    } else if (dataType === 'ExaminationType') {
      form.setFieldsValue({
        examinationType: e.id,
        examinationTypeName: e.name,
      })
      // return `考核类别`;
    } else if (dataType === 'ExaminationPerson') {
      // return `考核人`;
      form.setFieldsValue({
        examinationPerson: e.id,
        examinationPersonName: e.name,
      })
    } else if (dataType === 'ProductManger') {
      // return `产品经理`;
      form.setFieldsValue({
        productManager: e.name,
        productManagerId: e.id,
      })
    } else if (dataType === 'Owner') {
      form.setFieldsValue({
        ownerName: e.name,
        owner: e.code,
      })
    } else if (dataType === 'deliveryday') {
      form.setFieldsValue({
        deliveryDate: e.code,
        deliveryday: e.code,
      })
      console.group('选中行数据')
      console.groupEnd()
    }
    const action = setSwitchAction(false)
    dispatch(action)
    dispatch(setKeyNameAction(''))
  }

  // 根据四级类目编码查询类目税收信息
  const getTaxinfoByCategory = async (value: string) => {
    const res = await GET_TAXINFO_BY_CATEGORYCODE({ categoryCode: value })
    const { code, data } = res
    if (isResponseCodeSuccess(code) && data?.taxCategoryName) {
      form.setFieldsValue({
        taxCategoryCodeName: data?.taxCategoryName,
        taxCategoryCode: data?.taxCategoryCode,
        abbreviation: data?.abbreviation,
        taxCategoryRate: data?.taxCategoryRate,
      })
    }
  }
  // 选中类目树
  const onSelectTreeData = (e: selectNodeParam) => {
    if (e.level !== '4') {
      message.warning('请选择四级类目，进行操作！')
      return false
    }
    getTaxinfoByCategory(e.prefixCode)
    if (onChangeCate) {
      form.setFieldsValue({
        fourthCateMdmId: e.key,
        cateName: e.title,
      })
      onChangeCate(e.key, undefined, undefined, e.frontendHintText)
    }
    if (getTempCode) {
      if (e.prefixCode.includes('GH03')) {
        getTempCode('GH03')
      } else {
        getTempCode()
      }
    }
    const action = setSwitchAction(false)
    dispatch(action)
    dispatch(setKeyNameAction(''))
  }

  const onClickAiCategoryRecommend = async () => {
    const materialName = String(form.getFieldValue('name') || '').trim()
    if (!materialName) {
      message.warning('请先填写物料名称')
      return
    }
    setAiCategoryRecommendLoading(true)
    try {
      const recommendations = await fetchAiCategoryRecommendations(
        materialName,
        form.getFieldValue('remakers'),
      )
      const recommendation = getHighestConfidenceRecommendation(
        recommendations,
        90,
      )
      if (!recommendation) {
        message.warning('没找到符合的类目数据')
        return
      }
      onSelectTreeData(toCategorySelectNodeParam(recommendation))
    } catch {
      message.error('AI审核异常')
    } finally {
      setAiCategoryRecommendLoading(false)
    }
  }

  // 改变title
  const onChangeTitle = () => {
    if (dataType === 'Brand') {
      return '品牌'
    } else if (dataType === 'Category') {
      return '类目'
    } else if (dataType === 'Unit') {
      return '基本单位'
    } else if (dataType === 'Procurement') {
      return '采购员'
    } else if (dataType === 'ProcurementDept') {
      return '采购部门'
    } else if (dataType === 'ExaminationType') {
      return '考核类别'
    } else if (dataType === 'ExaminationPerson') {
      return '考核人'
    } else if (dataType === 'ProductManger') {
      return '产品经理'
    } else if (dataType === 'Owner') {
      return '货主'
    } else if (dataType === 'deliveryday') {
      return '发货期'
    }
    return '品牌'
  }

  // 关闭弹窗
  const onCancel = () => {
    const action = setSwitchAction(false)
    dispatch(action)
    dispatch(setKeyNameAction(''))
  }

  // 重置输入框
  const onClickdel = (e: string[]) => {
    form.resetFields(e)
  }

  const formItemLayout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
  }
  const itemLayou = {
    style: {
      width: '100%',
      marginBottom: '10px',
    },
  }

  // 检测费/安装费change
  const onChangeFee = (val: string, type: 'testingFee' | 'packingFee') => {
    switch (type) {
      case 'testingFee':
        dispatchRedux(setIncludeTestingAction(val))
        return
      case 'packingFee':
        dispatchRedux(setIncludePackingAction(val))
        return
    }
  }

  // 输入价格类表单失去焦点，格式化
  const onBlurPrice = async (field: string) => {
    const value = form.getFieldValue(field)
    form.setFieldsValue({
      [field]: formatterEditPrice(value),
    })
    await form.validateFields([field])
  }
  // 毛重校验
  const checkGrossweight = (rule: any, value: string) => {
    if (!value) {
      return Promise.resolve()
    }
    const regGrossweight = /^(\d{1,10}(?:\.\d{1,2})?)$/
    if (!regGrossweight.test(value) || value === '0') {
      return Promise.reject('毛重整数最多10位，小数最多2位')
    }
    return Promise.resolve()
  }
  return (
    <Form
      {...formItemLayout}
      form={form}
      labelAlign="right"
      style={{ margin: '10px 0 0 0', padding: '0 10px 0 0' }}
      size="small"
      colon={false}
      scrollToFirstError
      onFieldsChange={onFieldsChange}
    >
      <Row>
        <Col span={8}>
          <Form.Item name="id" noStyle>
            <Input hidden />
          </Form.Item>
          <Form.Item name="productMdmId" noStyle>
            <Input hidden />
          </Form.Item>
          {/* id */}
          <Form.Item label="编码" name="tempCode" {...itemLayou}>
            <Input
              readOnly
              disabled
              // placeholder='提交后系统自动生成'
            />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Tooltip
            getTooltipContainer={() => document.body}
            arrowPointAtCenter
            trigger="focus"
            title={
              <>
                {form.getFieldValue('shiBeiBrandName')
                  ? `拾取:${form.getFieldValue('shiBeiBrandName')}`
                  : '选择品牌，若品牌不存在请先新增'}
              </>
            }
          >
            <Form.Item
              label="品牌"
              name="brand"
              rules={[
                { required: true, whitespace: true, message: '请选择品牌' },
              ]}
              {...itemLayou}
              extra={
                <>
                  {preCheckErrors?.brandError ? (
                    <div
                      style={{
                        color: '#FF7D00',
                        fontSize: '14px',
                        lineHeight: '24px',
                      }}
                    >
                      {preCheckErrors.brandError}
                    </div>
                  ) : undefined}
                  <Extra reason={aiAuditErrorReasonForField?.brandName} />
                </>
              }
            >
              <Select
                id="brand"
                showSearch
                placeholder="请输入"
                {...renderSearchList('brand')}
              />
            </Form.Item>
          </Tooltip>
          {/* 品牌mdmId */}
          <Form.Item name="brandMdmId" noStyle style={{ display: 'none' }}>
            <Input hidden />
          </Form.Item>
          {/* 品牌中文名 */}
          <Form.Item name="brandNameCn" noStyle style={{ display: 'none' }}>
            <Input hidden />
          </Form.Item>
          {/* 品牌英文名 */}
          <Form.Item name="brandNameEn" noStyle style={{ display: 'none' }}>
            <Input hidden />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            label="名称"
            name="name"
            required
            {...itemLayou}
            rules={[
              {
                required: true,
                min: 1,
                max: 40,
                message:
                  '支持中英文数字标点符号；最短1字，最长40个字；禁止字符： ł、Š、ő、ç、Í、É、Ã、Ž、Ø、º、ñ、（间隔符号、不算）',
              },
              {
                validator: checkASCII,
              },
            ]}
            getValueFromEvent={(e) => {
              const evt: any = window.event
              let resStr = formatStr(e.target.value, 'other')
              if (evt.inputType === 'insertText') {
                // eslint-disable-next-line quotes
                resStr = resStr.replaceAll("'", '')
              }
              return resStr
            }}
            extra={
              <>
                <span
                  style={{
                    fontSize: '12px',
                    lineHeight: '24px',
                  }}
                >
                  以名词结尾；描述性词语放描述中；不能过长。
                </span>
                <Extra reason={aiAuditErrorReasonForField?.name} />
              </>
            }
          >
            <Input placeholder="请输入" maxLength={40} />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={8}>
          <Form.Item
            label="型号"
            name="spec"
            required
            getValueFromEvent={(e) => {
              let resStr = formatStr(e.target.value, 'other')
              if (e.nativeEvent?.inputType === 'insertText') {
                // eslint-disable-next-line quotes
                resStr = resStr.replaceAll("'", '')
              }
              return resStr
            }}
            {...itemLayou}
            rules={[
              { required: true, whitespace: true, message: '请输入型号' },
              { max: 40, message: '型号最多40字符' },
              {
                required: true,
                validator: productForbidCharValidator,
              },
            ]}
            extra={
              <>
                <span
                  style={{
                    fontSize: '12px',
                    lineHeight: '24px',
                  }}
                >
                  无型号可填规格，都无填/(不能写通用、常规)
                </span>
                <Extra reason={aiAuditErrorReasonForField?.manuCode} />
              </>
            }
          >
            <Input
              maxLength={40}
              placeholder="请输入"
              hidden={filteHidden('spec', FormState)}
              disabled={filteDisabled('spec', FormState)}
            />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            label="基本单位"
            name="baseunitName"
            rules={[
              { required: true, whitespace: true, message: '请选择基本单位' },
            ]}
            extra={
              <>
                {showUnitTip && (
                  <span
                    style={{
                      color: '#ff4d4f',
                      fontSize: '12px',
                      lineHeight: '24px',
                    }}
                  >
                    审核后无法修改，请确认！
                  </span>
                )}
                <Extra reason={aiAuditErrorReasonForField?.unitName} />
              </>
            }
            {...itemLayou}
          >
            <Select
              id="unitBasic"
              showSearch
              placeholder="请输入"
              disabled={filteDisabled('baseunit', FormState) || unitDisabled}
              {...renderSearchList('unit')}
            />
          </Form.Item>
          <Form.Item name="baseunit" noStyle style={{ display: 'none' }}>
            <Input hidden />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            label="类目"
            name="cateName"
            {...itemLayou}
            style={{ ...itemLayou.style, marginBottom: 0 }}
            rules={[
              { required: true, whitespace: true, message: '请选择类目' },
            ]}
            extra={
              categoryReadOnly || aiAuditErrorReasonForField?.catoyid?.length ? (
                <>
                  {categoryReadOnly && (
                    <span style={{ color: '#8C8C8C', fontSize: '12px' }}>
                      物料已审核通过，咸亨类目不可修改
                    </span>
                  )}
                  {aiAuditErrorReasonForField?.catoyid?.length ? (
                    <Extra reason={aiAuditErrorReasonForField.catoyid} />
                  ) : undefined}
                </>
              ) : undefined
            }
          >
            <Input
              readOnly
              onClick={() => !categoryReadOnly && onClickInput('Category')}
              disabled={
                categoryReadOnly ||
                filteDisabled('catoyid', FormState) ||
                aiCategoryRecommendLoading
              }
              style={{
                cursor:
                  categoryReadOnly ||
                  filteDisabled('catoyid', FormState) ||
                  aiCategoryRecommendLoading
                    ? 'not-allowed'
                    : 'pointer',
              }}
              hidden={filteHidden('catoyid', FormState)}
              suffix={
                !categoryReadOnly &&
                !filteDisabled('catoyid', FormState) &&
                !aiCategoryRecommendLoading ? (
                  <CloseCircleOutlined
                    className={Style['delicon']}
                    onClick={() => onClickdel(['cateName', 'fourthCateMdmId'])}
                  />
                ) : undefined
              }
            />
          </Form.Item>
          <Form.Item noStyle shouldUpdate>
            {({ getFieldValue }) =>
              !categoryReadOnly && !filteDisabled('catoyid', FormState) ? (
                <div className={Style['ai-category-recommend-action']}>
                  <Button
                    type="primary"
                    ghost
                    size="small"
                    loading={aiCategoryRecommendLoading}
                    disabled={
                      aiCategoryRecommendLoading ||
                      !String(getFieldValue('name') || '').trim()
                    }
                    onClick={onClickAiCategoryRecommend}
                  >
                    AI 建议类目
                  </Button>
                </div>
              ) : null
            }
          </Form.Item>
          {/* 类目ID */}
          <Form.Item name="fourthCateMdmId" noStyle>
            <Input hidden />
          </Form.Item>
          <Form.Item name="isAssessing" noStyle style={{ display: 'none' }}>
            <Input hidden />
          </Form.Item>
          <Form.Item name="cateMdmId" noStyle style={{ display: 'none' }}>
            <Input hidden />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={8}>
          <Form.Item
            label="毛重"
            name="grossweight"
            rules={[{ validator: checkGrossweight }]}
            getValueFromEvent={(e) => {
              return formatStr(e.target.value, 'NumberDecimal')
            }}
            extra="整数最多10位，小数最多2位"
            {...itemLayou}
          >
            <Input
              placeholder="请输入"
              suffix="kg"
              disabled={filteDisabled('grossweight', FormState)}
            />
          </Form.Item>
        </Col>

        <Col span={8}>
          <Form.Item
            label="市场价"
            name="marketprice"
            dependencies={['mallprice']}
            rules={[
              { required: true, message: '请输入市场价' },
              ...priceRules,
              {
                validator: (_, value) => {
                  const mallprice = form.getFieldValue('mallprice')
                  if (
                    mallprice !== undefined &&
                    mallprice !== null &&
                    String(mallprice).trim() !== '' &&
                    value !== undefined &&
                    value !== null &&
                    String(value).trim() !== '' &&
                    Number(value) <= Number(mallprice)
                  ) {
                    return Promise.reject(new Error('市场价必须大于参考供货价'))
                  }
                  return Promise.resolve()
                },
              },
            ]}
            getValueFromEvent={(e) => {
              return formatStr(e.target.value, 'NumberDecimal')
            }}
            {...itemLayou}
            extra={
              preCheckErrors?.marketPriceError ? (
                <div
                  style={{
                    color: '#FF7D00',
                    fontSize: '14px',
                    lineHeight: '24px',
                  }}
                >
                  {preCheckErrors.marketPriceError}
                </div>
              ) : undefined
            }
          >
            <Input
              placeholder="请输入"
              hidden={filteHidden('marketprice', FormState)}
              disabled={filteDisabled('marketprice', FormState)}
              suffix="元"
              onBlur={() => onBlurPrice('marketprice')}
            />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            label={
              <>
                {form.getFieldValue('productType') ===
                  materialTypeEnum.getValueByLabel('供应商物料') && (
                  <span style={{ color: 'red' }}>*</span>
                )}
                参考供货价
                <Tooltip
                  title="自然流量订单下，给咸亨的供货价"
                  getPopupContainer={() => document.body}
                >
                  <QuestionCircleOutlined />
                </Tooltip>
              </>
            }
            name="mallprice"
            rules={[
              // 使用 validator 实现动态校验，当 productType 为“电商供应商物料”时强制校验 mallprice 不为空。
              ...priceRules,
              {
                validator: (_, value) => {
                  const productType = form.getFieldValue('productType')
                  if (
                    materialTypeEnum.getLabelByValue(productType) ===
                      '供应商物料' &&
                    (!value || value === '')
                  ) {
                    return Promise.reject(new Error('请输入参考供货价'))
                  }
                  return Promise.resolve()
                },
              },
            ]}
            getValueFromEvent={(e) => {
              return formatStr(e.target.value, 'NumberDecimal')
            }}
            {...itemLayou}
            extra={
              <span
                style={{
                  fontSize: '12px',
                  lineHeight: '24px',
                }}
              >
                请填写含税价
              </span>
            }
          >
            <Input
              placeholder="请输入"
              hidden={filteHidden('mallprice', FormState)}
              disabled={filteDisabled('mallprice', FormState)}
              suffix="元"
              onBlur={() => onBlurPrice('mallprice')}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={6}>
          <Form.Item
            label="起订量"
            name="orderQuantity"
            rules={[
              {
                required: true,
                message: '请输入起订量',
              },
              {
                pattern: /^(?!0(\.0+)?$)(\d{1,7}(\.\d{1,3})?)$/,
                message: '大于0，小于一千万，最多保留三位小数',
              },
            ]}
            {...itemLayou}
          >
            <InputNumber
              style={{ width: '180px' }}
              max={9999999.999}
              min={0.001}
              precision={3}
              placeholder="请输入"
              hidden={filteHidden('orderQuantity', FormState)}
              disabled={filteDisabled('orderQuantity', FormState)}
            />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item label="是否倍数下单" name="isMultipleOrder" {...itemLayou}>
            <OneZeroCheckbox></OneZeroCheckbox>
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item label="含安装费" name="packingExpense" {...itemLayou}>
            <SingleAbleCheckbox
              dataSource={packingFeeList}
              onChange={(e) => onChangeFee(e, 'packingFee')}
            />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item label="含检测费" name="testingFee" {...itemLayou}>
            <SingleAbleCheckbox
              dataSource={testingFeeList}
              onChange={(e) => onChangeFee(e, 'testingFee')}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={16}>
          <Form.Item
            label="描述"
            labelCol={{ span: 4 }}
            wrapperCol={{ span: 20 }}
            style={{ margin: '0 0 10px 0' }}
            className={Style['remarks']}
            extra={
              <>
                <span
                  style={{
                    fontSize: '12px',
                    lineHeight: '24px',
                  }}
                >
                  1、单位为大规格如包/箱时描述需注明规格个数；2、名称、型号、描述中的内容不允许重复；3、产品本身若有不同的颜色款式，需在描述中注明，且和主图的颜色或款式描述一致。
                </span>
                <Extra reason={aiAuditErrorReasonForField?.description} />
              </>
            }
          >
            <div className={Style['remarks-box']}>
              <div className={Style['remarks-readonly']}>
                {getFeeText('testingFee', includeTestingFee)}
                {getFeeText('packingFee', includePackingFee)}
              </div>
              <Form.Item
                rules={[{ max: 200, message: '最多输入200字' }]}
                getValueFromEvent={(e) => {
                  let resStr = formatStr(e.target.value, 'Format')
                  if (e.nativeEvent?.inputType === 'insertText') {
                    /* eslint-disable */
                    resStr = resStr.replaceAll("'", '')
                  }
                  return resStr
                }}
                name="remakers"
              >
                <Input.TextArea
                  placeholder={
                    includeTestingFee || includePackingFee ? '' : '请输入'
                  }
                  hidden={filteHidden('remakers', FormState)}
                  disabled={filteDisabled('remakers', FormState)}
                  style={{ resize: 'none' }}
                  maxLength={200}
                />
              </Form.Item>
            </div>
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            label="含运费"
            name="freight"
            {...itemLayou}
            rules={[{ required: true, message: '请选择' }]}
            initialValue="1"
          >
            <Radio.Group size="small">
              <Radio value={'1'}>含</Radio>
              <Radio value={'0'}>不含</Radio>
            </Radio.Group>
          </Form.Item>
        </Col>
      </Row>
      <CustomModal
        open={visible}
        title={onChangeTitle()}
        footer={false}
        modalCancel={onCancel}
        width={dataType === 'Category' ? 820 : 460}
      >
        <Input.Search
          enterButton={
            <Button type="primary" size="small">
              <CustomeIcon
                type="icon-fangdajing"
                style={{ fontSize: '16px' }}
              />
            </Button>
          }
          size="small"
          placeholder="请输入名称"
          style={{ width: '260px', margin: '5px 0 10px 0' }}
          // onChange={(e) => onSearchData(e.target.value)}
          onSearch={(e) => onSearchData(e)}
        />
        {dataType === 'Procurement' ? (
          <Button style={{ margin: '5px 0px 10px' }} onClick={onRefresh}>
            <RedoOutlined />
            刷新
          </Button>
        ) : null}
        {dataType === 'Category' ? (
          <div style={{ display: 'flex', gap: 16 }}>
            <div style={{ width: 430, maxHeight: 400, overflow: 'auto' }}>
              <CustomTreeAll
                treeList={treeList.filter(
                  (item) => item.source !== CategorySourceData.PLM,
                )}
                selectNode={(e) => onSelectTreeData(e)}
                searchKey={keyName}
                materialType={materialType}
              />
            </div>
            <AiCategoryRecommend
              visible={visible && dataType === 'Category'}
              materialName={categoryRecommendMaterialName}
              description={categoryRecommendDescription}
              disabled={Boolean(filteDisabled('catoyid', FormState))}
              onSelectCategory={onSelectTreeData}
            />
          </div>
        ) : null}

        {dataType !== 'Category' ? (
          <MaterialPopTable
            dataSource={dataList}
            onChangePage={onChangePage}
            onClickRow={onClickRow}
            loading={loading}
            otherCol={
              dataType === 'Owner'
                ? [
                    {
                      title: '编码',
                      dataIndex: 'code',
                    },
                  ]
                : undefined
            }
            nameRender={
              dataType === 'Owner'
                ? (text: any) => (
                    <span
                      dangerouslySetInnerHTML={{
                        __html: htmlToRed(
                          text,
                          searchSelectParam.owner
                            ? searchSelectParam.owner
                            : '',
                        ),
                      }}
                    ></span>
                  )
                : undefined
            }
          />
        ) : null}
      </CustomModal>
    </Form>
  )
}

export default Maininfo
import React, { useEffect, useReducer, useRef, useState } from 'react'
import {
  Input,
  Form,
  Row,
  Button,
  message,
  Radio,
  Col,
  Tooltip,
  Select,
  List,
  Spin,
  InputNumber,
} from 'antd'
import { FormInstance } from 'antd/lib/form'
import { filteDisabled, filteHidden } from '../ControlformState/useFormState'
import { useTypedSelector } from '../../redux/store'
import Style from './detail.module.scss'
import {
  GET_OWNER_PAGES_API,
  GET_TYPE_API,
  // GET_ALLUNIT_API,
  GET_PRODUCT_CHECKMAN_API,
  GET_BRANDPAGE,
  GET_UNIT_PAGE,
  GET_TAXINFO_BY_CATEGORYCODE,
} from '../../api/MaterialApi'
import {
  RedoOutlined,
  CloseCircleOutlined,
  QuestionCircleOutlined,
} from '@ant-design/icons'
import CustomModal from '../../components/ModalUser'
import CustomeIcon from '../../components/IconUser'
import CustomTreeAll, { selectNodeParam } from '../../components/TreeAll'
import {
  formatStr,
  checkASCII,
  htmlToRed,
  formatSpecialCharacter,
  MaterialType,
  packingFeeList,
  testingFeeList,
  getFeeText,
  getSupplierId,
  isResponseCodeSuccess,
  // debounce,
  formatterEditPrice,
} from '../../tools/util'
import MaterialPopTable, {
  tableresultData,
  filterData,
  tableParam,
} from '../../components/MaterialTable'
import {
  GET_PARENTDEPARTMENT_API,
  GET_STAFF_API,
  FETCH_PURCHASE_API,
} from '../../api/CommonApi'
import { GET_PRODUCTMANAGER_LIST } from '../../api/System_Api'
import {
  setIncludePackingAction,
  setIncludeTestingAction,
  CategorySourceData,
} from './reducer'
import { useDispatch } from 'react-redux'
import SingleAbleCheckbox from '../../components/SingleAbleCheckbox'
import InfiniteScroll from 'react-infinite-scroll-component'
import OneZeroCheckbox from '@/components/OneZeroCheckbox'
// 7.1.3
import { materialTypeEnum } from '@/global/enum/product'
import { GlobalStorage } from '@/global/storage'
import { productForbidCharValidator } from '@/hooks/validate'
import { PreCheckErrors } from '@/api/MaterialApi'
import Extra from './extra'
import AiCategoryRecommend from './AiCategoryRecommend'
import {
  fetchAiCategoryRecommendations,
  getHighestConfidenceRecommendation,
  toCategorySelectNodeParam,
} from './aiCategoryRecommendUtils'

const ACTION_TYPE = {
  SWITCH_VISIBLE: 'MAIN/SWITCH_VISIBLE', // 控制弹窗显示隐藏
  SET_SWITCH_TYPE: 'MAIN/SET_SWITCH_TYPE', // 设置操作数据类型
  SET_DATA: 'MAIN/SET_DATA', // 设置数据
  SET_DATALIST: 'MAIN/SET_DATALIST', // 设置 过滤 数据
  SET_KEYNAME: 'MAIN/SET_KEYNAME', // 设置 搜索 数据
  SET_LOADING: 'MAIN/SET_LOADING', // 设置loading
  SET_OWNER_DATA: 'SET_OWNER_DATA', // 货主
  SET_SEARCH_PARAM: 'SET_SEARCH_PARAM', // 弹窗搜索关键字
  SET_UNIT_OPTION: 'SET_UNIT_OPTION', // 设置单位
  SET_PAGE: 'SET_PAGE',
  SET_BRAND_DATA: 'SET_BRAND_DATA',
  SEARCH_VALUE: 'SEARCH_VALUE',
}
// 数据类型
type Operationdatatype =
  | 'Brand'
  | 'Owner'
  | 'Category'
  | 'Unit'
  | 'Procurement'
  | 'ProcurementDept'
  | 'ExaminationType'
  | 'ExaminationPerson'
  | 'deliveryday'
  | 'ProductManger'

interface select {
  label: string
  value: string
}
interface State {
  visible: boolean
  dataType: Operationdatatype
  dataSource: tableresultData // 数据源
  dataList: tableresultData
  keyName: string // 搜索数据
  loading: boolean
  ownerData: any[] // 货主列表
  searchSelectParam: { owner?: string } // 弹窗搜索关键字
  unitOption: select[]
  currentPage: number
  brandData: tableresultData
  searchValue: string
}
const defaultState: State = {
  visible: false,
  dataType: 'Brand',
  dataSource: {
    current: 1,
    total: 0,
    data: [],
  },
  dataList: { current: 1, total: 0, data: [] },
  keyName: '',
  loading: false,
  ownerData: [],
  searchSelectParam: { owner: '' },
  unitOption: [],
  currentPage: 1,
  brandData: {
    current: 1,
    total: 0,
    data: [],
  },
  searchValue: '',
}
const reducer = (
  state = defaultState,
  action: { type: string; value?: any },
) => {
  const arr = { ...state }
  switch (action.type) {
    case ACTION_TYPE.SWITCH_VISIBLE:
      arr.visible = action.value
      return arr
    case ACTION_TYPE.SET_SWITCH_TYPE:
      arr.dataType = action.value
      return arr
    case ACTION_TYPE.SET_UNIT_OPTION:
      arr.unitOption = action.value
      return arr
    case ACTION_TYPE.SET_PAGE:
      arr.currentPage = action.value
      return arr
    case ACTION_TYPE.SET_BRAND_DATA:
      arr.brandData = action.value
      return arr
    case ACTION_TYPE.SEARCH_VALUE:
      arr.searchValue = action.value
      return arr
    case ACTION_TYPE.SET_DATA:
      arr.dataSource = action.value
      return arr
    case ACTION_TYPE.SET_DATALIST:
      arr.dataList = action.value
      return arr
    case ACTION_TYPE.SET_KEYNAME:
      arr.keyName = action.value
      return arr
    case ACTION_TYPE.SET_LOADING:
      arr.loading = action.value
      return arr
    case ACTION_TYPE.SET_OWNER_DATA:
      arr.ownerData = action.value
      return arr
    case ACTION_TYPE.SET_SEARCH_PARAM:
      arr.searchSelectParam = action.value
      return arr
    default:
      return arr
  }
}

// 搜索内容
const changeSearchSelectParamAction = (param: any) => ({
  type: ACTION_TYPE.SET_SEARCH_PARAM,
  value: param,
})

const setSwitchAction = (param: boolean) => ({
  type: ACTION_TYPE.SWITCH_VISIBLE,
  value: param,
})
const setBrandDataAction = (param: tableresultData) => ({
  type: ACTION_TYPE.SET_BRAND_DATA,
  value: param,
})
const setSearchValueAction = (param: string) => ({
  type: ACTION_TYPE.SEARCH_VALUE,
  value: param,
})
const setLoadingAction = (param: boolean) => ({
  type: ACTION_TYPE.SET_LOADING,
  value: param,
})
const setDataTypeAction = (param: Operationdatatype) => ({
  type: ACTION_TYPE.SET_SWITCH_TYPE,
  value: param,
})
const setDataAction = (param: tableresultData) => ({
  type: ACTION_TYPE.SET_DATA,
  value: param,
})

const setDataFilterAction = (param: tableresultData) => ({
  type: ACTION_TYPE.SET_DATALIST,
  value: param,
})
const setKeyNameAction = (param: string) => ({
  type: ACTION_TYPE.SET_KEYNAME,
  value: param,
})
// 搜索货主
const setOwnerDataAction = (param: any[]) => ({
  type: ACTION_TYPE.SET_OWNER_DATA,
  value: param,
})

export const adjustPriceRules = [
  {
    pattern: /^(([1-9]{1}\d*)|(0{1}))(\.\d{1,2})?$/,
    message: '请输入大于0且含有2位小数的数字',
  },
]

export const priceRules = [
  {
    pattern: /^(?!0(\.0{1,2})?$)([1-9]\d{0,6}(\.\d{1,2})?|0\.\d{1,2})$/,
    message: '大于0保留两位小数，小于9999999.99',
  },
]

export const weightRules = [
  {
    pattern: /^(?!0(\.0*)?$)(?![0-9]{14,}\b)\d{1,13}(\.\d{0,13})?$/,
    message: '请输入大于0且含有两位小数的1-13位数字',
  },
  {
    pattern: /^(([1-9]{1}\d*)|(0{1}))(\.\d{1,2})?$/,
    message: '请输入大于0且含有两位小数的1-13位数字',
  },
]

interface Props {
  form: FormInstance
  categoryReadOnly?: boolean
  onChangeCate?: (
    e: string,
    type?: string,
    materialCode?: string,
    frontendHintText?: string,
  ) => void // 类目改变
  onChangeSale?: (e: string) => void // 品牌改变
  onChangeDept?: (e: string) => void // 部门改变
  currentThis?: any // 当前
  tempCode?: string
  unitDisabled?: boolean // 基本单位是否禁用
  showUnitTip?: boolean // 基本单位备注
  getTempCode?: (preCode?: string) => Promise<void> // 获取临时编码
  materialType?: MaterialType
  onFieldsChange: () => void
  preCheckErrors?: PreCheckErrors
  aiAuditErrorReasonForField?: any
}

// 主要信息
const Maininfo: React.FC<Props> = (props) => {
  const {
    form,
    categoryReadOnly = false,
    onChangeCate,
    onChangeDept,
    tempCode,
    unitDisabled,
    showUnitTip,
    getTempCode,
    materialType,
    onFieldsChange,
    preCheckErrors,
    aiAuditErrorReasonForField,
  } = props
  const { FormState } = useTypedSelector((state) => state.ControlformState)
  const { includeTestingFee, includePackingFee } = useTypedSelector(
    (state) => state.goodsReducer,
  )
  const dispatchRedux = useDispatch()
  const [state, dispatch] = useReducer(reducer, defaultState)
  const {
    visible,
    dataType,
    dataList,
    keyName,
    loading,
    ownerData,
    searchSelectParam,
    brandData,
  } = state
  const { treeList } = useTypedSelector((state) => state.treeReducer)
  const [loadingList, setLoadingList] = useState(false)
  const [brandOpen, setBrandOpen] = useState(false)
  const [unitOpen, setUnitOpen] = useState(false)
  const [onSearchValue, setOnSearchValue] = useState('')
  const [aiCategoryRecommendLoading, setAiCategoryRecommendLoading] =
    useState(false)
  const [categoryRecommendMaterialName, setCategoryRecommendMaterialName] =
    useState('')
  const [categoryRecommendDescription, setCategoryRecommendDescription] =
    useState('')
  const timeoutId = useRef<NodeJS.Timeout | null>(null)
  useEffect(() => {
    dispatchRedux(setIncludeTestingAction(form.getFieldValue('testingFee')))
    dispatchRedux(setIncludePackingAction(form.getFieldValue('packingExpense')))
    // eslint-disable-next-line
  }, [form.getFieldValue('testingFee'), form.getFieldValue('packingExpense')])

  useEffect(() => {
    if (tempCode) {
      form.setFieldsValue({
        tempCode: tempCode,
      })
    }
    // eslint-disable-next-line
  }, [tempCode])

  // 刷新 采购人员
  async function onRefresh() {
    message.loading('数据正在刷新中，请稍后...', 0)
    const resData: any = await FETCH_PURCHASE_API()
    if (resData.code === 0) {
      message.success('刷新成功！')
    }
  }

  // 点击输入框
  const onClickInput = async (param: Operationdatatype) => {
    if (
      param === 'Category' &&
      (filteDisabled('catoyid', FormState) || aiCategoryRecommendLoading)
    ) {
      return
    }
    if (param === 'Category') {
      setCategoryRecommendMaterialName(form.getFieldValue('name') || '')
      setCategoryRecommendDescription(form.getFieldValue('remakers') || '')
    }
    //  显示弹窗 loading 设置当前操作类型
    dispatch(setSwitchAction(true))
    dispatch(setLoadingAction(true))
    dispatch(setDataTypeAction(param))
    let resData: tableresultData = {
      current: 1,
      total: 0,
      data: [],
    }
    if (param === 'Owner') {
      resData = await getOwnerData()
    }
    if (param === 'Brand') {
      resData = await getBrandData(1)
    }
    if (param === 'Category') {
    }
    if (param === 'Unit') {
      resData = await getUnitData(1)
    }
    if (param === 'Procurement') {
      resData = await getProcurementData(1)
    }
    if (param === 'ProcurementDept') {
      resData = await getProcurementDept(1)
    }
    if (param === 'ExaminationType') {
      resData = await getExaminationType(1)
    }
    if (param === 'ProductManger') {
      resData = await getProductManager(1)
    }
    if (param === 'ExaminationPerson') {
      resData = await getExaminationPerson(1)
    }
    // 存原始数据
    dispatch(setDataAction(resData))
    // 设置过滤数据
    dispatch(setDataFilterAction(resData))
    // loading结束
    dispatch(setLoadingAction(false))
  }

  // 搜索数据
  async function onSearchData(e: string) {
    let data: tableresultData = {
      current: 1,
      total: 0,
      data: [],
    }
    // 记录搜索条件
    dispatch(setKeyNameAction(e))
    switch (dataType) {
      case 'Owner':
        data = searchOwner(e)
        break
      case 'Brand':
        data = await getBrandData(1, e)
        break
      case 'Category':
        break
      case 'Unit':
        data = await getUnitData(1, e)
        break
      case 'Procurement':
        data = await getProcurementData(1, e)
        break
      case 'ProcurementDept':
        data = await getProcurementDept(1, e)
        break
      case 'ExaminationType':
        data = await getExaminationType(1, e)
        break
      case 'ProductManger':
        data = await getProductManager(1, e)
        break
      case 'ExaminationPerson':
        data = await getExaminationPerson(1, e)
        break
      default:
        break
    }
    dispatch(setDataFilterAction(data))
  }

  // 分页
  const onChangePage = async (page: number) => {
    //   loading
    dispatch(setLoadingAction(true))
    let resData: tableresultData = {
      current: 1,
      total: 0,
      data: [],
    }
    if (dataType === 'Brand') {
      resData = await getBrandData(page, keyName)
    }
    if (dataType === 'Category') {
    }
    if (dataType === 'Unit') {
      resData = await getUnitData(page, keyName)
    }
    if (dataType === 'Procurement') {
      resData = await getProcurementData(page, keyName)
    }
    if (dataType === 'ProcurementDept') {
      resData = await getProcurementDept(page, keyName)
    }
    if (dataType === 'ExaminationType') {
      resData = await getExaminationType(page, keyName)
    }
    if (dataType === 'ProductManger') {
      resData = await getProductManager(page, keyName)
    }
    if (dataType === 'ExaminationPerson') {
      resData = await getExaminationPerson(page, keyName)
    }
    // 存原始数据
    dispatch(setDataAction(resData))
    // 设置过滤数据
    dispatch(setDataFilterAction(resData))
    // loading结束
    dispatch(setLoadingAction(false))
  }

  // 获取货主数据
  const getOwnerData = async (): Promise<tableresultData> => {
    const resData = await GET_OWNER_PAGES_API({
      supplierid: getSupplierId(),
    })
    if (resData.code === 0) {
      resData.data.forEach((item: any) => {
        item.id = item.mdmId
      })
      dispatch(setOwnerDataAction(resData.data))
      return {
        data: resData.data,
      }
    }
    return {
      current: 1,
      total: 0,
      data: [],
    }
  }

  // 获取货主数据
  const searchOwner = (str?: string) => {
    dispatch(changeSearchSelectParamAction({ owner: str }))
    return {
      current: 1,
      total: 0,
      data: str
        ? ownerData.filter((item) =>
            new RegExp(formatSpecialCharacter(str), 'gi').test(item.name),
          )
        : [...ownerData],
    }
  }

  // 获取品牌数据
  const getBrandData = async (
    page: number,
    str?: string,
    loading?: boolean,
  ): Promise<tableresultData> => {
    setLoadingList(true)
    const resData: any = await GET_BRANDPAGE({
      brandName: str, // 筛选条件
      supplierId: getSupplierId(),
      pageNo: page, // 页码
      pageSize: 20, // 分页尺寸
    })
    if (resData.code === 0) {
      const data = resData.data.content
      const arr = data.map((item: any) => ({
        name: `${item.brandNameCn}/${item.brandNameEn}/${item.brandCode}`,
        brandEn: item.brandNameEn,
        brandCn: item.brandNameCn,
        id: Math.random().toString(36).substr(2),
        mdmId: item.brandMdmId,
      }))
      const result = loading ? brandData.data.concat(arr) : arr
      dispatch(
        setBrandDataAction({
          current: resData.data.pageNo,
          total: resData.data.totalCount,
          data: result,
        }),
      )
      dispatch(setSearchValueAction(str || ''))
      setLoadingList(false)
      return {
        current: resData.data.pageNo,
        total: resData.data.totalCount,
        data: result,
      }
    }
    dispatch(
      setBrandDataAction({
        current: 1,
        total: 0,
        data: [],
      }),
    )
    setLoadingList(false)
    return brandData
  }

  // 获取单位数据
  const getUnitData = async (
    page: number,
    str?: string,
    loading?: boolean,
  ): Promise<tableresultData> => {
    setLoadingList(true)
    const resData: any = await GET_UNIT_PAGE({
      name: str, // 筛选条件
      pageNo: page, // 页码
      pageSize: 20, // 分页尺寸
    })
    if (isResponseCodeSuccess(resData.code))
      if (resData.code === 0) {
        const data = resData.data.content
        // type 1 基准单位 成本和基本单位相同数据 其他全部展示 value 显示unit数值
        // const list = data.filter((item: any) => item.type === '1');
        const arr = data.map(
          (item: { name: string; type: string; unit: string }) => ({
            name: item.name + '/' + item.unit,
            code: item.unit,
            id: item.unit,
          }),
        )
        const result = loading ? brandData.data.concat(arr) : arr
        dispatch(
          setBrandDataAction({
            current: resData.data.pageNo,
            total: resData.data.totalCount,
            data: result,
          }),
        )
        dispatch(setSearchValueAction(str || ''))
        setLoadingList(false)
        return {
          current: resData.data.pageNo,
          total: resData.data.totalCount,
          data: result,
        }
      }
    dispatch(
      setBrandDataAction({
        current: 1,
        total: 0,
        data: [],
      }),
    )
    setLoadingList(false)
    return brandData
  }

  const renderSearchList = (type: string) => {
    const open = type === 'brand' ? brandOpen : unitOpen
    const throttleSearch = (value: string) => {
      setOnSearchValue(value)
      if (!value) {
        dispatch(
          setBrandDataAction({
            current: 1,
            total: 0,
            data: [],
          }),
        )
        return
      }
      if (timeoutId) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        clearTimeout(timeoutId.current)
      }
      timeoutId.current = setTimeout(() => {
        if (type === 'brand') {
          setBrandOpen(true)
          getBrandData(1, value)
        } else {
          setUnitOpen(true)
          getUnitData(1, value)
        }
      }, 200)
    }
    return {
      onSearch: throttleSearch,
      dropdownRender: () => (
        <div
          id={'scrollableDiv' + type}
          style={{ height: 200, display: open ? '' : 'none' }}
        >
          <InfiniteScroll
            dataLength={brandData.data.length}
            next={() =>
              type === 'brand'
                ? getBrandData(
                    (brandData.current || 0) + 1,
                    onSearchValue,
                    true,
                  )
                : getUnitData(
                    (brandData.current || 0) + 1,
                    form.getFieldValue(type),
                    true,
                  )
            }
            hasMore={(brandData.current || 0) * 20 < (brandData.total || 0)}
            loader={<Spin spinning={loadingList} />}
            endMessage=""
            scrollableTarget={'scrollableDiv' + type}
            height={200}
          >
            <List
              dataSource={brandData.data}
              renderItem={(item) => (
                <List.Item
                  key={item.id}
                  onClick={(e) => {
                    e.stopPropagation()
                    if (type === 'brand') {
                      clickBrand(item)
                    } else {
                      clickUnit(item)
                    }
                  }}
                >
                  <div className={Style['brand-item']}>{item.name}</div>
                </List.Item>
              )}
            />
          </InfiniteScroll>
        </div>
      ),
    }
  }

  // 获取采购员
  const getProcurementData = async (page: number, str?: string) => {
    const depId = form.getFieldValue('procurementDept')
    const resData: any = await GET_STAFF_API({
      deptId: depId ? depId : '',
    })
    if (resData.code === 0) {
      const data = resData.data
      // 设置id
      const arr = data.map(
        (item: {
          id: string
          empName: string
          empId: string
          empCode: string
          deptId: string
          deptName: string
          jobName: string
        }) => ({
          name: `${item.empName}-${item.deptName}-${item.jobName}`,
          id: item.empId,
          empId: item.empId,
          deptId: item.deptId,
          deptName: item.deptName,
          code: item.empCode,
        }),
      )
      return filterData(arr, str, String(page))
    }
    return {
      current: 1,
      total: 0,
      data: [],
    }
  }

  // 获取采购部门
  const getProcurementDept = async (
    page: number,
    str?: string,
  ): Promise<tableresultData> => {
    const create_code = form.getFieldValue('create_code')
    const resData: any = await GET_PARENTDEPARTMENT_API({
      createcode: create_code ? create_code : '', // 创建组织
      pushState: '1', // 推送状态
    })
    if (resData.code === 0) {
      const data = resData.data
      const arr = data.map(
        (item: { name: string; id: string; code: string }) => ({
          name: item.name,
          id: item.id,
          code: item.code,
        }),
      )
      return filterData(arr, str, String(page))
    }
    return {
      current: 1,
      total: 0,
      data: [],
    }
  }

  // 获取考核类别
  const getExaminationType = async (
    page: number,
    str?: string,
  ): Promise<tableresultData> => {
    const depId = form.getFieldValue('procurementDept')
    const resData: any = await GET_TYPE_API({
      deptId: depId, // 部门id
    })
    if (resData.code === 0) {
      const data = resData.data
      const arr = data.map((item: { name: string; code: string }) => ({
        name: item.name,
        code: item.code,
        id: item.code,
      }))
      return filterData(arr, str, String(page))
    }
    return {
      current: 1,
      total: 0,
      data: [],
    }
  }

  // 获取考核人员
  const getExaminationPerson = async (
    page: number,
    str?: string,
  ): Promise<tableresultData> => {
    const resData: any = await GET_PRODUCT_CHECKMAN_API({
      key: str, // 搜索内容
      limit: 10, // 分页尺寸
      page: page, // 页码
    })
    if (resData.code === 0) {
      const data = resData.data
      const total = resData.count
      const current = resData.curPage
      const arr = data.map(
        (item: { name: string; id: string; code: string }) => ({
          name: item.name,
          id: item.id,
          code: item.code,
        }),
      )
      return {
        current: current,
        total: total,
        data: arr,
      }
    }
    return {
      current: 1,
      total: 0,
      data: [],
    }
  }

  // 获取产品经理
  const getProductManager = async (
    page: number,
    str?: string,
  ): Promise<tableresultData> => {
    const resData = await GET_PRODUCTMANAGER_LIST({
      name: str,
      limit: 10, // 分页尺寸
      page: page, // 页码
    })
    if (resData.code === 0) {
      const data = resData.data
      const total = resData.count
      const current = resData.curPage
      const arr = data.map(
        (item: { name: string; id: string }, index: number) => ({
          name: item.name,
          id: item.id,
          code: index + 1,
        }),
      )
      return {
        current: current,
        total: total,
        data: arr,
      }
    }
    return {
      current: 1,
      total: 0,
      data: [],
    }
  }

  const clickBrand = (e: tableParam) => {
    form.setFieldsValue({
      brand: e.name,
      brandMdmId: e.mdmId, // mdmid
      brandNameCn: e.brandCn, // 选择的品牌是否可售不可售
      brandNameEn: e.brandEn,
    })
    setBrandOpen(false)
    dispatch(setSearchValueAction(e.name))
    dispatch(
      setBrandDataAction({
        current: 1,
        total: 0,
        data: [],
      }),
    )
    setTimeout(() => {
      const item = document.getElementById('brand')
      if (item) {
        item.blur()
      }
    })
  }

  const clickUnit = (e: tableParam) => {
    // 改变基本单位 同步改变 库存单位 成本单位 销售单位 销售计价单位 采购单位 采购计价单位
    form.setFieldsValue({
      baseunit: e.id,
      baseunitName: e.name,
      inventoryunit: e.id,
      inventoryunitName: e.name,
      costunit: e.id,
      costunitName: e.name,
      salesunit: e.id,
      salesunitName: e.name,
      salesvaluaunit: e.id,
      salesvaluaunitName: e.name,
      procureunit: e.id,
      procureunitName: e.name,
      procurevaluaunit: e.id,
      procurevaluaunitName: e.name,
    })
    setUnitOpen(false)
    dispatch(setSearchValueAction(e.name))
    dispatch(
      setBrandDataAction({
        current: 1,
        total: 0,
        data: [],
      }),
    )
    setTimeout(() => {
      const item = document.getElementById('unitBasic')
      if (item) {
        item.blur()
      }
    })
  }

  // 选中当前行数据
  const onClickRow = (e: tableParam) => {
    if (dataType === 'Brand') {
      form.setFieldsValue({
        brand: e.name,
        brandMdmId: e.mdmId, // mdmid
        brandNameCn: e.brandCn, // 选择的品牌是否可售不可售
        brandNameEn: e.brandEn,
      })
    } else if (dataType === 'Unit') {
      // 改变基本单位 同步改变 库存单位 成本单位 销售单位 销售计价单位 采购单位 采购计价单位
      form.setFieldsValue({
        baseunit: e.id,
        baseunitName: e.name,
        inventoryunit: e.id,
        inventoryunitName: e.name,
        costunit: e.id,
        costunitName: e.name,
        salesunit: e.id,
        salesunitName: e.name,
        salesvaluaunit: e.id,
        salesvaluaunitName: e.name,
        procureunit: e.id,
        procureunitName: e.name,
        procurevaluaunit: e.id,
        procurevaluaunitName: e.name,
      })
      // return `基本单位`;
    } else if (dataType === 'Procurement') {
      // 选中采购 固定采购部门
      form.resetFields(['examinationType', 'examinationTypeName'])
      form.setFieldsValue({
        procurement: e.empId,
        procurementName: e.name,
        procurementDept: e.deptId,
        procurementDeptName: e.deptName,
      })
      if (onChangeDept) {
        onChangeDept(e.deptId)
      }
      // return `采购员`;
    } else if (dataType === 'ProcurementDept') {
      // 选中部门 重置采购员 考核类别
      form.resetFields([
        'procurement',
        'procurementName',
        'examinationType',
        'examinationTypeName',
      ])
      form.setFieldsValue({
        procurementDept: e.id,
        procurementDeptName: e.name,
      })
      if (onChangeDept) {
        onChangeDept(e.id)
      }
      // return `采购部门`;
    } else if (dataType === 'ExaminationType') {
      form.setFieldsValue({
        examinationType: e.id,
        examinationTypeName: e.name,
      })
      // return `考核类别`;
    } else if (dataType === 'ExaminationPerson') {
      // return `考核人`;
      form.setFieldsValue({
        examinationPerson: e.id,
        examinationPersonName: e.name,
      })
    } else if (dataType === 'ProductManger') {
      // return `产品经理`;
      form.setFieldsValue({
        productManager: e.name,
        productManagerId: e.id,
      })
    } else if (dataType === 'Owner') {
      form.setFieldsValue({
        ownerName: e.name,
        owner: e.code,
      })
    } else if (dataType === 'deliveryday') {
      form.setFieldsValue({
        deliveryDate: e.code,
        deliveryday: e.code,
      })
      console.group('选中行数据')
      console.groupEnd()
    }
    const action = setSwitchAction(false)
    dispatch(action)
    dispatch(setKeyNameAction(''))
  }

  // 根据四级类目编码查询类目税收信息
  const getTaxinfoByCategory = async (value: string) => {
    const res = await GET_TAXINFO_BY_CATEGORYCODE({ categoryCode: value })
    const { code, data } = res
    if (isResponseCodeSuccess(code) && data?.taxCategoryName) {
      form.setFieldsValue({
        taxCategoryCodeName: data?.taxCategoryName,
        taxCategoryCode: data?.taxCategoryCode,
        abbreviation: data?.abbreviation,
        taxCategoryRate: data?.taxCategoryRate,
      })
    }
  }
  // 选中类目树
  const onSelectTreeData = (e: selectNodeParam) => {
    if (e.level !== '4') {
      message.warning('请选择四级类目，进行操作！')
      return false
    }
    getTaxinfoByCategory(e.prefixCode)
    if (onChangeCate) {
      form.setFieldsValue({
        fourthCateMdmId: e.key,
        cateName: e.title,
      })
      onChangeCate(e.key, undefined, undefined, e.frontendHintText)
    }
    if (getTempCode) {
      if (e.prefixCode.includes('GH03')) {
        getTempCode('GH03')
      } else {
        getTempCode()
      }
    }
    const action = setSwitchAction(false)
    dispatch(action)
    dispatch(setKeyNameAction(''))
  }

  const onClickAiCategoryRecommend = async () => {
    const materialName = String(form.getFieldValue('name') || '').trim()
    if (!materialName) {
      message.warning('请先填写物料名称')
      return
    }
    setAiCategoryRecommendLoading(true)
    try {
      const recommendations = await fetchAiCategoryRecommendations(
        materialName,
        form.getFieldValue('remakers'),
      )
      const recommendation = getHighestConfidenceRecommendation(
        recommendations,
        90,
      )
      if (!recommendation) {
        message.warning('没找到符合的类目数据')
        return
      }
      onSelectTreeData(toCategorySelectNodeParam(recommendation))
    } catch {
      message.error('AI审核异常')
    } finally {
      setAiCategoryRecommendLoading(false)
    }
  }

  // 改变title
  const onChangeTitle = () => {
    if (dataType === 'Brand') {
      return '品牌'
    } else if (dataType === 'Category') {
      return '类目'
    } else if (dataType === 'Unit') {
      return '基本单位'
    } else if (dataType === 'Procurement') {
      return '采购员'
    } else if (dataType === 'ProcurementDept') {
      return '采购部门'
    } else if (dataType === 'ExaminationType') {
      return '考核类别'
    } else if (dataType === 'ExaminationPerson') {
      return '考核人'
    } else if (dataType === 'ProductManger') {
      return '产品经理'
    } else if (dataType === 'Owner') {
      return '货主'
    } else if (dataType === 'deliveryday') {
      return '发货期'
    }
    return '品牌'
  }

  // 关闭弹窗
  const onCancel = () => {
    const action = setSwitchAction(false)
    dispatch(action)
    dispatch(setKeyNameAction(''))
  }

  // 重置输入框
  const onClickdel = (e: string[]) => {
    form.resetFields(e)
  }

  const formItemLayout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
  }
  const itemLayou = {
    style: {
      width: '100%',
      marginBottom: '10px',
    },
  }

  // 检测费/安装费change
  const onChangeFee = (val: string, type: 'testingFee' | 'packingFee') => {
    switch (type) {
      case 'testingFee':
        dispatchRedux(setIncludeTestingAction(val))
        return
      case 'packingFee':
        dispatchRedux(setIncludePackingAction(val))
        return
    }
  }

  // 输入价格类表单失去焦点，格式化
  const onBlurPrice = async (field: string) => {
    const value = form.getFieldValue(field)
    form.setFieldsValue({
      [field]: formatterEditPrice(value),
    })
    await form.validateFields([field])
  }
  // 毛重校验
  const checkGrossweight = (rule: any, value: string) => {
    if (!value) {
      return Promise.resolve()
    }
    const regGrossweight = /^(\d{1,10}(?:\.\d{1,2})?)$/
    if (!regGrossweight.test(value) || value === '0') {
      return Promise.reject('毛重整数最多10位，小数最多2位')
    }
    return Promise.resolve()
  }
  return (
    <Form
      {...formItemLayout}
      form={form}
      labelAlign="right"
      style={{ margin: '10px 0 0 0', padding: '0 10px 0 0' }}
      size="small"
      colon={false}
      scrollToFirstError
      onFieldsChange={onFieldsChange}
    >
      <Row>
        <Col span={8}>
          <Form.Item name="id" noStyle>
            <Input hidden />
          </Form.Item>
          <Form.Item name="productMdmId" noStyle>
            <Input hidden />
          </Form.Item>
          {/* id */}
          <Form.Item label="编码" name="tempCode" {...itemLayou}>
            <Input
              readOnly
              disabled
              // placeholder='提交后系统自动生成'
            />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Tooltip
            getTooltipContainer={() => document.body}
            arrowPointAtCenter
            trigger="focus"
            title={
              <>
                {form.getFieldValue('shiBeiBrandName')
                  ? `拾取:${form.getFieldValue('shiBeiBrandName')}`
                  : '选择品牌，若品牌不存在请先新增'}
              </>
            }
          >
            <Form.Item
              label="品牌"
              name="brand"
              rules={[
                { required: true, whitespace: true, message: '请选择品牌' },
              ]}
              {...itemLayou}
              extra={
                <>
                  {preCheckErrors?.brandError ? (
                    <div
                      style={{
                        color: '#FF7D00',
                        fontSize: '14px',
                        lineHeight: '24px',
                      }}
                    >
                      {preCheckErrors.brandError}
                    </div>
                  ) : undefined}
                  <Extra reason={aiAuditErrorReasonForField?.brandName} />
                </>
              }
            >
              <Select
                id="brand"
                showSearch
                placeholder="请输入"
                {...renderSearchList('brand')}
              />
            </Form.Item>
          </Tooltip>
          {/* 品牌mdmId */}
          <Form.Item name="brandMdmId" noStyle style={{ display: 'none' }}>
            <Input hidden />
          </Form.Item>
          {/* 品牌中文名 */}
          <Form.Item name="brandNameCn" noStyle style={{ display: 'none' }}>
            <Input hidden />
          </Form.Item>
          {/* 品牌英文名 */}
          <Form.Item name="brandNameEn" noStyle style={{ display: 'none' }}>
            <Input hidden />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            label="名称"
            name="name"
            required
            {...itemLayou}
            rules={[
              {
                required: true,
                min: 1,
                max: 40,
                message:
                  '支持中英文数字标点符号；最短1字，最长40个字；禁止字符： ł、Š、ő、ç、Í、É、Ã、Ž、Ø、º、ñ、（间隔符号、不算）',
              },
              {
                validator: checkASCII,
              },
            ]}
            getValueFromEvent={(e) => {
              const evt: any = window.event
              let resStr = formatStr(e.target.value, 'other')
              if (evt.inputType === 'insertText') {
                // eslint-disable-next-line quotes
                resStr = resStr.replaceAll("'", '')
              }
              return resStr
            }}
            extra={
              <>
                <span
                  style={{
                    fontSize: '12px',
                    lineHeight: '24px',
                  }}
                >
                  以名词结尾；描述性词语放描述中；不能过长。
                </span>
                <Extra reason={aiAuditErrorReasonForField?.name} />
              </>
            }
          >
            <Input placeholder="请输入" maxLength={40} />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={8}>
          <Form.Item
            label="型号"
            name="spec"
            required
            getValueFromEvent={(e) => {
              let resStr = formatStr(e.target.value, 'other')
              if (e.nativeEvent?.inputType === 'insertText') {
                // eslint-disable-next-line quotes
                resStr = resStr.replaceAll("'", '')
              }
              return resStr
            }}
            {...itemLayou}
            rules={[
              { required: true, whitespace: true, message: '请输入型号' },
              { max: 40, message: '型号最多40字符' },
              {
                required: true,
                validator: productForbidCharValidator,
              },
            ]}
            extra={
              <>
                <span
                  style={{
                    fontSize: '12px',
                    lineHeight: '24px',
                  }}
                >
                  无型号可填规格，都无填/(不能写通用、常规)
                </span>
                <Extra reason={aiAuditErrorReasonForField?.manuCode} />
              </>
            }
          >
            <Input
              maxLength={40}
              placeholder="请输入"
              hidden={filteHidden('spec', FormState)}
              disabled={filteDisabled('spec', FormState)}
            />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            label="基本单位"
            name="baseunitName"
            rules={[
              { required: true, whitespace: true, message: '请选择基本单位' },
            ]}
            extra={
              <>
                {showUnitTip && (
                  <span
                    style={{
                      color: '#ff4d4f',
                      fontSize: '12px',
                      lineHeight: '24px',
                    }}
                  >
                    审核后无法修改，请确认！
                  </span>
                )}
                <Extra reason={aiAuditErrorReasonForField?.unitName} />
              </>
            }
            {...itemLayou}
          >
            <Select
              id="unitBasic"
              showSearch
              placeholder="请输入"
              disabled={filteDisabled('baseunit', FormState) || unitDisabled}
              {...renderSearchList('unit')}
            />
          </Form.Item>
          <Form.Item name="baseunit" noStyle style={{ display: 'none' }}>
            <Input hidden />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            label="类目"
            name="cateName"
            {...itemLayou}
            style={{ ...itemLayou.style, marginBottom: 0 }}
            rules={[
              { required: true, whitespace: true, message: '请选择类目' },
            ]}
            extra={
              categoryReadOnly || aiAuditErrorReasonForField?.catoyid?.length ? (
                <>
                  {categoryReadOnly && (
                    <span style={{ color: '#8C8C8C', fontSize: '12px' }}>
                      物料已审核通过，咸亨类目不可修改
                    </span>
                  )}
                  {aiAuditErrorReasonForField?.catoyid?.length ? (
                    <Extra reason={aiAuditErrorReasonForField.catoyid} />
                  ) : undefined}
                </>
              ) : undefined
            }
          >
            <Input
              readOnly
              onClick={() => !categoryReadOnly && onClickInput('Category')}
              disabled={
                categoryReadOnly ||
                filteDisabled('catoyid', FormState) ||
                aiCategoryRecommendLoading
              }
              style={{
                cursor:
                  categoryReadOnly ||
                  filteDisabled('catoyid', FormState) ||
                  aiCategoryRecommendLoading
                    ? 'not-allowed'
                    : 'pointer',
              }}
              hidden={filteHidden('catoyid', FormState)}
              suffix={
                !categoryReadOnly &&
                !filteDisabled('catoyid', FormState) &&
                !aiCategoryRecommendLoading ? (
                  <CloseCircleOutlined
                    className={Style['delicon']}
                    onClick={() => onClickdel(['cateName', 'fourthCateMdmId'])}
                  />
                ) : undefined
              }
            />
          </Form.Item>
          <Form.Item noStyle shouldUpdate>
            {({ getFieldValue }) =>
              !categoryReadOnly && !filteDisabled('catoyid', FormState) ? (
                <div className={Style['ai-category-recommend-action']}>
                  <Button
                    type="primary"
                    ghost
                    size="small"
                    loading={aiCategoryRecommendLoading}
                    disabled={
                      aiCategoryRecommendLoading ||
                      !String(getFieldValue('name') || '').trim()
                    }
                    onClick={onClickAiCategoryRecommend}
                  >
                    AI 建议类目
                  </Button>
                </div>
              ) : null
            }
          </Form.Item>
          {/* 类目ID */}
          <Form.Item name="fourthCateMdmId" noStyle>
            <Input hidden />
          </Form.Item>
          <Form.Item name="isAssessing" noStyle style={{ display: 'none' }}>
            <Input hidden />
          </Form.Item>
          <Form.Item name="cateMdmId" noStyle style={{ display: 'none' }}>
            <Input hidden />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={8}>
          <Form.Item
            label="毛重"
            name="grossweight"
            rules={[{ validator: checkGrossweight }]}
            getValueFromEvent={(e) => {
              return formatStr(e.target.value, 'NumberDecimal')
            }}
            extra="整数最多10位，小数最多2位"
            {...itemLayou}
          >
            <Input
              placeholder="请输入"
              suffix="kg"
              disabled={filteDisabled('grossweight', FormState)}
            />
          </Form.Item>
        </Col>

        <Col span={8}>
          <Form.Item
            label="市场价"
            name="marketprice"
            dependencies={['mallprice']}
            rules={[
              { required: true, message: '请输入市场价' },
              ...priceRules,
              {
                validator: (_, value) => {
                  const mallprice = form.getFieldValue('mallprice')
                  if (
                    mallprice !== undefined &&
                    mallprice !== null &&
                    String(mallprice).trim() !== '' &&
                    value !== undefined &&
                    value !== null &&
                    String(value).trim() !== '' &&
                    Number(value) <= Number(mallprice)
                  ) {
                    return Promise.reject(new Error('市场价必须大于参考供货价'))
                  }
                  return Promise.resolve()
                },
              },
            ]}
            getValueFromEvent={(e) => {
              return formatStr(e.target.value, 'NumberDecimal')
            }}
            {...itemLayou}
            extra={
              preCheckErrors?.marketPriceError ? (
                <div
                  style={{
                    color: '#FF7D00',
                    fontSize: '14px',
                    lineHeight: '24px',
                  }}
                >
                  {preCheckErrors.marketPriceError}
                </div>
              ) : undefined
            }
          >
            <Input
              placeholder="请输入"
              hidden={filteHidden('marketprice', FormState)}
              disabled={filteDisabled('marketprice', FormState)}
              suffix="元"
              onBlur={() => onBlurPrice('marketprice')}
            />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            label={
              <>
                {form.getFieldValue('productType') ===
                  materialTypeEnum.getValueByLabel('供应商物料') && (
                  <span style={{ color: 'red' }}>*</span>
                )}
                参考供货价
                <Tooltip
                  title="自然流量订单下，给咸亨的供货价"
                  getPopupContainer={() => document.body}
                >
                  <QuestionCircleOutlined />
                </Tooltip>
              </>
            }
            name="mallprice"
            rules={[
              // 使用 validator 实现动态校验，当 productType 为“电商供应商物料”时强制校验 mallprice 不为空。
              ...priceRules,
              {
                validator: (_, value) => {
                  const productType = form.getFieldValue('productType')
                  if (
                    materialTypeEnum.getLabelByValue(productType) ===
                      '供应商物料' &&
                    (!value || value === '')
                  ) {
                    return Promise.reject(new Error('请输入参考供货价'))
                  }
                  return Promise.resolve()
                },
              },
            ]}
            getValueFromEvent={(e) => {
              return formatStr(e.target.value, 'NumberDecimal')
            }}
            {...itemLayou}
            extra={
              <span
                style={{
                  fontSize: '12px',
                  lineHeight: '24px',
                }}
              >
                请填写含税价
              </span>
            }
          >
            <Input
              placeholder="请输入"
              hidden={filteHidden('mallprice', FormState)}
              disabled={filteDisabled('mallprice', FormState)}
              suffix="元"
              onBlur={() => onBlurPrice('mallprice')}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={6}>
          <Form.Item
            label="起订量"
            name="orderQuantity"
            rules={[
              {
                required: true,
                message: '请输入起订量',
              },
              {
                pattern: /^(?!0(\.0+)?$)(\d{1,7}(\.\d{1,3})?)$/,
                message: '大于0，小于一千万，最多保留三位小数',
              },
            ]}
            {...itemLayou}
          >
            <InputNumber
              style={{ width: '180px' }}
              max={9999999.999}
              min={0.001}
              precision={3}
              placeholder="请输入"
              hidden={filteHidden('orderQuantity', FormState)}
              disabled={filteDisabled('orderQuantity', FormState)}
            />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item label="是否倍数下单" name="isMultipleOrder" {...itemLayou}>
            <OneZeroCheckbox></OneZeroCheckbox>
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item label="含安装费" name="packingExpense" {...itemLayou}>
            <SingleAbleCheckbox
              dataSource={packingFeeList}
              onChange={(e) => onChangeFee(e, 'packingFee')}
            />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item label="含检测费" name="testingFee" {...itemLayou}>
            <SingleAbleCheckbox
              dataSource={testingFeeList}
              onChange={(e) => onChangeFee(e, 'testingFee')}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={16}>
          <Form.Item
            label="描述"
            labelCol={{ span: 4 }}
            wrapperCol={{ span: 20 }}
            style={{ margin: '0 0 10px 0' }}
            className={Style['remarks']}
            extra={
              <>
                <span
                  style={{
                    fontSize: '12px',
                    lineHeight: '24px',
                  }}
                >
                  1、单位为大规格如包/箱时描述需注明规格个数；2、名称、型号、描述中的内容不允许重复；3、产品本身若有不同的颜色款式，需在描述中注明，且和主图的颜色或款式描述一致。
                </span>
                <Extra reason={aiAuditErrorReasonForField?.description} />
              </>
            }
          >
            <div className={Style['remarks-box']}>
              <div className={Style['remarks-readonly']}>
                {getFeeText('testingFee', includeTestingFee)}
                {getFeeText('packingFee', includePackingFee)}
              </div>
              <Form.Item
                rules={[{ max: 200, message: '最多输入200字' }]}
                getValueFromEvent={(e) => {
                  let resStr = formatStr(e.target.value, 'Format')
                  if (e.nativeEvent?.inputType === 'insertText') {
                    /* eslint-disable */
                    resStr = resStr.replaceAll("'", '')
                  }
                  return resStr
                }}
                name="remakers"
              >
                <Input.TextArea
                  placeholder={
                    includeTestingFee || includePackingFee ? '' : '请输入'
                  }
                  hidden={filteHidden('remakers', FormState)}
                  disabled={filteDisabled('remakers', FormState)}
                  style={{ resize: 'none' }}
                  maxLength={200}
                />
              </Form.Item>
            </div>
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            label="含运费"
            name="freight"
            {...itemLayou}
            rules={[{ required: true, message: '请选择' }]}
            initialValue="1"
          >
            <Radio.Group size="small">
              <Radio value={'1'}>含</Radio>
              <Radio value={'0'}>不含</Radio>
            </Radio.Group>
          </Form.Item>
        </Col>
      </Row>
      <CustomModal
        open={visible}
        title={onChangeTitle()}
        footer={false}
        modalCancel={onCancel}
        width={dataType === 'Category' ? 820 : 460}
      >
        <Input.Search
          enterButton={
            <Button type="primary" size="small">
              <CustomeIcon
                type="icon-fangdajing"
                style={{ fontSize: '16px' }}
              />
            </Button>
          }
          size="small"
          placeholder="请输入名称"
          style={{ width: '260px', margin: '5px 0 10px 0' }}
          // onChange={(e) => onSearchData(e.target.value)}
          onSearch={(e) => onSearchData(e)}
        />
        {dataType === 'Procurement' ? (
          <Button style={{ margin: '5px 0px 10px' }} onClick={onRefresh}>
            <RedoOutlined />
            刷新
          </Button>
        ) : null}
        {dataType === 'Category' ? (
          <div style={{ display: 'flex', gap: 16 }}>
            <div style={{ width: 430, maxHeight: 400, overflow: 'auto' }}>
              <CustomTreeAll
                treeList={treeList.filter(
                  (item) => item.source !== CategorySourceData.PLM,
                )}
                selectNode={(e) => onSelectTreeData(e)}
                searchKey={keyName}
                materialType={materialType}
              />
            </div>
            <AiCategoryRecommend
              visible={visible && dataType === 'Category'}
              materialName={categoryRecommendMaterialName}
              description={categoryRecommendDescription}
              disabled={Boolean(filteDisabled('catoyid', FormState))}
              onSelectCategory={onSelectTreeData}
            />
          </div>
        ) : null}

        {dataType !== 'Category' ? (
          <MaterialPopTable
            dataSource={dataList}
            onChangePage={onChangePage}
            onClickRow={onClickRow}
            loading={loading}
            otherCol={
              dataType === 'Owner'
                ? [
                    {
                      title: '编码',
                      dataIndex: 'code',
                    },
                  ]
                : undefined
            }
            nameRender={
              dataType === 'Owner'
                ? (text: any) => (
                    <span
                      dangerouslySetInnerHTML={{
                        __html: htmlToRed(
                          text,
                          searchSelectParam.owner
                            ? searchSelectParam.owner
                            : '',
                        ),
                      }}
                    ></span>
                  )
                : undefined
            }
          />
        ) : null}
      </CustomModal>
    </Form>
  )
}

export default Maininfo
